import angular from 'angular';

import componentsModule from './components';

export default angular.module('portainer.environments', [componentsModule])
  .name;
